import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { ClientproxyApiClient } from "../clients/ClientproxyApiClient";
import { IPumpPerformanceCurvesParameters } from "./models/IPumpPerformanceCurvesParameters";
import { ICalculatedCurvesResult } from "./models/ICalculatedCurvesResult";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class PumpPerformanceCurvesService
{
    private readonly url: string;
    constructor(private readonly apiClient: ClientproxyApiClient)
    {
        this.url = "pumpperformancecurves";
    }

    async getCalculatedCurvesAsync(parameters: IPumpPerformanceCurvesParameters): Promise<ICalculatedCurvesResult>
    {
        return await this.apiClient.post<ICalculatedCurvesResult>(`${this.url}/getcurves`, {}, JSON.stringify(parameters));
    }
}